module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI 凌霄子母路由器.a84596c7.png";